import React from "react";
import { Spin } from "antd";

export const Loading = (props) => {
  return props.contentPreloader ? <Spin className="content-preloader" /> : <Spin />;
};
